/**
 * DreamPay Private API [DEPRECATED]
 * ⚠️ **DEPRECATED** - This API version is deprecated and will be removed on 2026-05-31. Please migrate to V2.  Private API v1 - Legacy endpoints for DreamPay payment processing platform.
 *
 * The version of the OpenAPI document: v1
 * Contact: suporte@dreampay.com.br
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface Email {
  id?: number;
  to?: string | null;
  cc?: string | null;
  bcc?: string | null;
  subject?: string | null;
  message?: string | null;
  attachments?: string | null;
  imageToUse?: string | null;
  emailTitle?: string | null;
  processed?: boolean | null;
  processedAt?: string | null;
  language?: string | null;
}
